import { toast } from 'sonner';
import { isInDesignConstructor } from './buyback';
import { VaultedToastBody } from './VaultedToastBody';
import { isNotificationShown } from './visibility';

/** What put the cards in the vault — each has its own constructor switch:
 *  `vault` the player tapped Vault, `exit` they left a reveal with packs
 *  still sealed ("Close and vault"). */
export type VaultedTrigger = 'vault' | 'exit';

const SWITCH_BY_TRIGGER = {
  vault: '--ui-notification-vaulted',
  exit: '--ui-notification-exit-vaulted',
} as const;

/**
 * "N card(s) added to your vault" — sleek's counterpart of the buyback toast
 * (partner feedback 2026-10-01), fired when a reveal ends on Vault or the
 * player closes the reveal and the remaining packs are vaulted. Same slot and
 * editor behaviour as {@link notifyBuyback}.
 *
 * @param count Cards that just landed in the vault.
 * @param imageUrl One of those cards, shown as the toast's thumbnail.
 * @param trigger Which constructor switch decides whether it shows.
 */
export function notifyVaulted(count: number, imageUrl: string | null | undefined, trigger: VaultedTrigger) {
  if (!isNotificationShown(SWITCH_BY_TRIGGER[trigger])) return;
  const inEditor = isInDesignConstructor();
  toast.custom(
    (t) => (
      <div
        onClick={inEditor ? () => toast.dismiss(t) : undefined}
        role={inEditor ? 'button' : undefined}
        style={inEditor ? { cursor: 'pointer' } : undefined}
        title={inEditor ? 'Click to dismiss (editor only)' : undefined}
      >
        <VaultedToastBody count={count} imageUrl={imageUrl ?? null} />
      </div>
    ),
    {
      position: 'top-left',
      ...(inEditor ? { duration: Infinity } : {}),
    },
  );
}
